<div class="outer-container">

  <button 
  *ngIf="!isConsumerCurriculum"
  [disabled]="(gradeChangedObject | json) == '{}' || submitInProgress" 
  class="btn btn-blue" 
  (click)="onSubmit()">
    <mat-spinner color="accent" [diameter]="16" *ngIf="submitInProgress"></mat-spinner>
    <span *ngIf="!submitInProgress">Update Grade</span>
  </button>

  <button class="button secondary-button mb-15" (click)="back()">Back</button>


  <div class="top-container" fxLayout="row" fxLayoutAlign="flex-start center">
    <mat-icon class="work-icon">
      description
    </mat-icon>
    <div>
      <div class="title">
        {{ assignmentName }}
      </div>
      <div class="sub-title">
        Viewing the work history of <b>{{ studentName }}</b>
      </div>
    </div>
  </div>

  <app-filter-questions
  [isConsumerCurriculum]="isConsumerCurriculum"
  ></app-filter-questions>

  <div *ngIf="!workDataReceived" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
  </div>

  
  <div *ngIf="workDataReceived" class="questions-container">
    <div *ngFor="let question of studentWorkData.Questions">
      <div *ngIf="!isConsumerCurriculum || (isConsumerCurriculum && !question.HideFromConsumerCurriculum)" [ngSwitch]="question.QuestionTypeEnumValue">
        <app-fact *ngSwitchCase="1" [question]="question" [isConsumerCurriculum]="isConsumerCurriculum" ></app-fact>
        <app-multiple-choice *ngSwitchCase="2" [question]="question" [isConsumerCurriculum]="isConsumerCurriculum" (gradeChanges)="gradeChanged($event)"></app-multiple-choice>
        <app-multiple-choice *ngSwitchCase="3" [question]="question" [isConsumerCurriculum]="isConsumerCurriculum" (gradeChanges)="gradeChanged($event)"></app-multiple-choice>
        <app-short-answer *ngSwitchCase="4" [question]="question" [isConsumerCurriculum]="isConsumerCurriculum" (gradeChanges)="gradeChanged($event)"></app-short-answer>
        <app-essay *ngSwitchCase="5" [question]="question" [isConsumerCurriculum]="isConsumerCurriculum" (gradeChanges)="gradeChanged($event)"></app-essay>
        <div class="category" 
        [hidden]="isConsumerCurriculum && (question.HideFromConsumerCurriculum)" 
        *ngSwitchDefault>{{question.QuestionText}}</div>
      </div>
    </div>
  </div>
</div>
